var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7005_3190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.10041 9.09375C1.84006 7.68853 2.08986 6.23652 2.80482 4.99908C3.51979 3.76164 4.65297 2.82004 6.00041 2.34375V6.84375L2.10041 9.09375Z",
    stroke: "#8A8B91",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 8.02625V2C9.05114 2.00016 10.0839 2.2765 10.9947 2.80135C11.9055 3.3262 12.6625 4.08114 13.1897 4.99057C13.717 5.89999 13.9961 6.93199 13.999 7.9832C14.0019 9.03442 13.7286 10.068 13.2065 10.9803C12.6843 11.8927 11.9316 12.6519 11.0238 13.1818C10.1159 13.7117 9.08472 13.9939 8.03352 13.9999C6.98232 14.0059 5.94797 13.7357 5.03407 13.2162C4.12017 12.6968 3.35879 11.9463 2.82617 11.04L7.99992 8.02625Z",
    stroke: "#8A8B91",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7005_3190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.114cbfeafb341fb80e41df3a661bcbc3.svg";
export { ForwardRef as ReactComponent };